import {
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Flex,
  Heading,
  Text,
} from '@chakra-ui/react'
import ArrowIcon from 'components/UI/Icons/ArrowIcon'
import React, { memo, useEffect, useState } from 'react'
import { colors } from 'shared/style/colors'
import { useQuery } from '@apollo/client'
import LoadingSpinner from 'components/UI/LoadingSpinner'
import { GET_TAGS } from 'services/tags/graphql'

const TagsSelector = memo(({ selectedTags, handleAddTag }) => {
  const [hover, setHover] = useState(false)
  const [visibleTags, setVisibleTags] = useState([])

  const { data: allTags, loading: isTagsLoading } = useQuery(GET_TAGS, {
    fetchPolicy: 'cache-and-network',
  })

  useEffect(() => {
    if (allTags && !isTagsLoading) {
      const ignoreList = [
        ...selectedTags.map(item => ({ tag_id: item.tag_id })),
      ]
      setVisibleTags(
        (allTags.tags ?? []).filter(
          item => !ignoreList.some(selected => selected.tag_id === item.tag_id),
        ),
      )
    }
  }, [allTags, isTagsLoading, selectedTags])

  return (
    <AccordionItem border='none'>
      {({ isExpanded }) => (
        <Flex
          bg='white'
          w='100%'
          borderRadius='8px'
          direction='column'
          border={
            hover || isExpanded
              ? `1px solid ${colors['primary-violet-100']}`
              : `1px solid ${colors['primary-gray-30']}`
          }
        >
          <AccordionButton
            _hover={{
              bg: 'white',
            }}
            p='8px 44px'
            m='0'
            borderRadius='8px'
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            outline='none'
            _focus={{
              boxShadow: 'none',
            }}
          >
            <Flex direction='column' flex={1} gap='12px'>
              <Heading
                size='poppins24'
                variant='primary-black-text'
                color={
                  hover || isExpanded
                    ? colors['primary-blue-100']
                    : colors['primary-black-text']
                }
                lineHeight='38px'
                letterSpacing='0'
                textAlign='left'
              >
                Tags
              </Heading>
            </Flex>

            {isExpanded ? (
              <Box p='10px' bg={colors['primary-violet-10']} borderRadius='50%'>
                <Box transform='rotate(180deg)'>
                  <ArrowIcon
                    fill={
                      hover
                        ? colors['button-hover']
                        : colors['primary-violet-100']
                    }
                  />
                </Box>
              </Box>
            ) : (
              <Box p='10px' bg={colors['primary-violet-10']} borderRadius='50%'>
                <Box>
                  <ArrowIcon
                    fill={
                      hover
                        ? colors['button-hover']
                        : colors['primary-violet-100']
                    }
                  />
                </Box>
              </Box>
            )}
          </AccordionButton>
          <AccordionPanel>
            {isTagsLoading && <LoadingSpinner />}

            <Flex gap='10px' wrap='wrap'>
              {visibleTags.map(item => (
                <Flex
                  key={item.tag_id}
                  gap='8px'
                  border={`1px solid ${colors['primary-gray-30']}`}
                  p='8px 12px'
                  boxShadow='0px 5px 15px 0px rgba(36, 28, 88, 0.20)'
                  borderRadius='8px'
                  cursor='pointer'
                  _hover={{
                    bg: 'rgba(36, 28, 88, 0.03)',
                  }}
                  onClick={() => handleAddTag(item)}
                >
                  <Flex w='100%' gap='10px' direction='column'>
                    <Text
                      size='poppins14'
                      variant='primary-black-text'
                      fontWeight={600}
                    >
                      {item.title}
                    </Text>
                  </Flex>
                </Flex>
              ))}
            </Flex>
          </AccordionPanel>
        </Flex>
      )}
    </AccordionItem>
  )
})

export default TagsSelector
